import { Injectable } from '@angular/core';
import {FormTO} from "../classes/form-to";
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ProcessBuilderTO} from "../classes/process-builder-to";
import {ProcessFlatNode} from "../classes/process-flat-node";
import {TransformUntilMe} from "../classes/transform-until-me";
import {Transformation} from "../classes/transformation";
import {ProcessType} from "../classes/process-type";
import {Locale} from "../classes/locale";
import {FileImportTO} from "../classes/file-import-to";
import {ProcessTranslations} from "../classes/process-translations";
import {BooleanTO} from "../classes/boolean-to";
import {Process} from "../classes/process";

@Injectable({
  providedIn: 'root'
})
export class ProcessBuilderService {

  private _localeDefaultCode = 'en';
  private _form: FormTO;
  private _processNode: ProcessFlatNode;

  private _processBuilderMode: ProcessType = undefined;
  private _processBuilderModeSource: BehaviorSubject<ProcessType> = new BehaviorSubject(this._processBuilderMode);
  private _processBuilderMode$ = this._processBuilderModeSource.asObservable();

  private _processBuilderHome: boolean = undefined;
  private _processBuilderHomeSource: BehaviorSubject<boolean> = new BehaviorSubject(this._processBuilderHome);
  private _processBuilderHome$ = this._processBuilderHomeSource.asObservable();

  constructor(private http: HttpClient) { }

  // public getForms(): Observable<Object> {
  //   return this.http.get('/rest/form/list');
  // }

  public getFormProcesses(form: FormTO): Observable<Object> {
    // console.log('getFormTOModel.form');
    // console.dir(form);
    return this.http.post('/rest/form/processes', form);
  }

  public saveFormProcess(processBuilderTO: ProcessBuilderTO): Observable<Object> {
    return this.http.post('/rest/form/process/save', processBuilderTO);
  }

  public saveFormProcessOutputModel(processBuilderTO: ProcessBuilderTO): Observable<Object> {
    return this.http.post('/rest/form/process/form/save', processBuilderTO);
  }

  get processBuilderMode$(): Observable<ProcessType> {
    return this._processBuilderMode$;
  }

  set processBuilderMode(processType: ProcessType) {
    this._processBuilderMode = processType;
    this._processBuilderModeSource.next(this._processBuilderMode);
  }

  get processBuilderHome$(): Observable<boolean> {
    return this._processBuilderHome$;
  }

  set processBuilderHome(goHome: boolean) {
    this._processBuilderHome = goHome;
    this._processBuilderHomeSource.next(this._processBuilderHome);
  }

  public get form(): FormTO {
    this._form = JSON.parse(sessionStorage.getItem('sproutFormTO')) as FormTO;
    return this._form;
  }

  public set form(value: FormTO) {
    this._form = value;
    sessionStorage.setItem('sproutFormTO', JSON.stringify(this._form));
  }

  public get processNode(): ProcessFlatNode {
    this._processNode = JSON.parse(sessionStorage.getItem('sproutProcessNode')) as ProcessFlatNode;
    return this._processNode;
  }

  public set processNode(value: ProcessFlatNode) {
    this._processNode = value;
    sessionStorage.setItem('sproutProcessNode', JSON.stringify(this._processNode));
  }

  processUntilMe(transformUntilMe: TransformUntilMe) {
    transformUntilMe.input = JSON.stringify(transformUntilMe.input);
    return this.http.post<TransformUntilMe>('/rest/form/process/transformUntilMe', transformUntilMe);
  }

  execute(transformation: Transformation) {
    return this.http.post<Transformation>('/rest/form/process/transform', transformation);
  }

  public getProcessTypes(): Observable<ProcessType[]> {
    return this.http.get<ProcessType[]>('/rest/form/process/types');
  }

  public getLocales(): Observable<Locale[]> {
    return this.http.get<Locale[]>('/rest/form/process/locales');
  }

  get localeDefaultCode(): string {
    return this._localeDefaultCode;
  }

  importTranslations(fileImportTO: FileImportTO) {
    return this.http.post<ProcessTranslations>('/rest/form/import/translations', fileImportTO);
  }

  saveTemplate(transformationNode: ProcessFlatNode): Observable<Object> {
    return this.http.post<BooleanTO>('/rest/form/process/template/save', transformationNode);
  }

  getTemplate(transformationNode: ProcessFlatNode) {
    return this.http.post<Process>('/rest/form/process/template', transformationNode);
  }

  getFormModel(formId: number) {
    return this.http.post<BooleanTO>('/rest/form/process/form', formId);
  }
}
